/**
 *	The utils.ObjectFunc class works as the util for object method.
 */
export default {
    //--------------------------------------------------
    // api
    //--------------------------------------------------
    /**
     * @api
     * Clone the object via JSON Serialization and deSerialization.
     * Use stringify method to convert object to string.
     * Use parse method to convert string to object.
     * @param source The source object.
     * @return The cloned object.
     */
    cloneObject(source) {
        let cloned;
        if (source && JSON && JSON.stringify && JSON.parse) {
            cloned = JSON.parse(JSON.stringify(source));
        }
        return cloned;
    },
    /**
     * @api
     * Complete the value with the certain separator. 
     * Convert the value object into the String.
     * Use the padStart method to complete the separator units.
     * @param value The value object.
     * @param length The restrict length number.
     * @param separator The separator unit and '0' as default.
     * @return The padded string.
     */
    pad: function(value, length, separator) {
        separator = separator || '0'
        return value.toString().padStart(length, separator)
    }
}